import React from 'react'
import { Modal, View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import ExitIcon from './Headers/UIButtons'
import { largeTextSize, mediumTextSize } from '../constants/GlobalStyle'
import { useAppDispatch, useAppSelector } from '../state/hooks'
import { hideAlert } from '../state/Slices/settingsSlice'

const CustomAlert = () => {
	const { alertConfig } = useAppSelector(state => state.settings)
	const dispatch = useAppDispatch()
	const {
		visible,
		title,
		body,
		buttonA,
		buttonB,
		onPressA,
		onPressB,
		showExitIcon,
		onPressExit,
		boldButton,
		colorA,
		colorB,
	} = alertConfig

	const shouldStackButtons = (buttonA && buttonA.length > 6) || (buttonB && buttonB.length > 6)

	const handlePressA = () => {
		onPressA && onPressA()
		dispatch(hideAlert())
	}

	const handlePressB = () => {
		onPressB && onPressB()
		dispatch(hideAlert())
	}

	return (
		<Modal visible={visible} transparent animationType="fade">
			<View style={styles.overlay}>
				<View style={[styles.alertBox, shouldStackButtons && styles.alertBoxWide]}>
					{/* {showExitIcon && (
						<TouchableOpacity onPress={onPressExit} style={styles.exitIcon}>
							<ExitIcon onPress={onPressExit} style={{ top: -5, right: -5 }} />
						</TouchableOpacity>
					)} */}
					<Text style={styles.title}>{title}</Text>
					<Text style={styles.body}>{body}</Text>
					<View
						style={[styles.buttonContainer, shouldStackButtons && styles.buttonContainerStacked]}
					>
						{/* Render buttonA or default button */}
						<TouchableOpacity
							style={[
								styles.button,
								{ backgroundColor: colorA || global.orgColor2, paddingHorizontal: 10 },
								shouldStackButtons && styles.fullWidthButton,
							]}
							onPress={handlePressA}
						>
							<Text style={[styles.buttonText, boldButton === 'A' && styles.boldText]}>
								{buttonA || 'OK'}
							</Text>
						</TouchableOpacity>
						{/* Render buttonB if provided */}
						{buttonB && (
							<TouchableOpacity
								style={[
									styles.button,
									{ backgroundColor: colorB || global.orgColor, paddingHorizontal: 10 },
									shouldStackButtons && styles.fullWidthButton,
								]}
								onPress={handlePressB}
							>
								<Text style={[styles.buttonText, boldButton === 'B' && styles.boldText]}>
									{buttonB}
								</Text>
							</TouchableOpacity>
						)}
					</View>
				</View>
			</View>
		</Modal>
	)
}

const styles = StyleSheet.create({
	overlay: {
		flex: 1,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		alignItems: 'center',
		justifyContent: 'center',
	},
	alertBox: {
		padding: 20,
		backgroundColor: 'white',
		borderRadius: 8,
		alignItems: 'center',
		maxWidth: 350,
	},
	alertBoxWide: {
		width: 330,
	},
	exitIcon: {
		position: 'absolute',
		top: 10,
		right: 10,
	},
	title: {
		fontSize: largeTextSize,
		fontWeight: 'bold',
		marginBottom: 10,
		textAlign: 'center',
	},
	body: {
		fontSize: mediumTextSize,
		textAlign: 'center',
		marginBottom: 20,
	},
	buttonContainer: {
		flexDirection: 'row',
		width: '100%',
		justifyContent: 'space-around',
	},
	buttonContainerStacked: {
		flexDirection: 'column',
	},
	button: {
		flexDirection: 'row',
		borderRadius: 8,
		alignItems: 'center',
		justifyContent: 'center',
		paddingHorizontal: 10,
		paddingVertical: 10,
		backgroundColor: 'black',
		flex: 1,
		marginHorizontal: 5,
	},
	fullWidthButton: {
		width: '100%',
		marginHorizontal: 0,
		marginBottom: 10,
	},
	buttonText: {
		color: 'white',
		fontWeight: '400',
		fontSize: largeTextSize,
	},
	boldText: {
		fontWeight: '600',
	},
})

export default CustomAlert
